class ScrollParallax {
  constructor() {
    this.elements = Array.from(document.querySelectorAll("[data-parallax]"));
    this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (!this.elements.length || this.prefersReducedMotion || window.innerWidth < 768) {
      return;
    }

    this.init();
  }

  init() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.dataset.visible = "true";
        } else {
          delete entry.target.dataset.visible;
        }
      });
    }, {
      rootMargin: "20% 0px",
    });

    this.elements.forEach((el) => {
      this.observer.observe(el);
      const speed = parseFloat(el.getAttribute("data-parallax") || "0.1");
      el._parallaxSpeed = speed;
    });

    window.addEventListener("scroll", () => this.onScroll(), { passive: true });
    window.addEventListener("resize", () => this.onResize(), { passive: true });

    // Initial position check
    this.tick();
  }

  onScroll() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.tick();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  onResize() {
    if (window.innerWidth < 768) {
      this.elements.forEach((el) => {
        el.style.removeProperty("--parallax-y");
      });
    } else {
      this.tick();
    }
  }

  tick() {
    if (window.innerWidth < 768) {
      return;
    }

    const vh = window.innerHeight;
    const viewportCenter = vh / 2;

    this.elements.forEach((el) => {
      if (!el.dataset.visible) {
        return;
      }

      const rect = el.getBoundingClientRect();
      const elCenter = rect.top + rect.height / 2;
      const distanceFromCenter = elCenter - viewportCenter;
      const y = distanceFromCenter * el._parallaxSpeed;

      el.style.setProperty("--parallax-y", `${y}px`);
    });
  }
}

new ScrollParallax();
